import styled from 'styled-components'

export const DeviceContainer = styled.div`
  padding: ${({ theme }) => theme.spacing[60]};
`

export const DeviceTitle = styled.h2`
  margin: 0 0 ${({ theme }) => theme.spacing[60]} 0;
  color: ${({ theme }) => theme.palette.text.default};
  font-size: ${({ theme }) => theme.typography.heading.size.lg};
  font-weight: ${({ theme }) => theme.typography.weight.semibold};
`

export const SectionTitle = styled.h3`
  margin: ${({ theme }) => theme.spacing[60]} 0 ${({ theme }) => theme.spacing[40]} 0;
  color: ${({ theme }) => theme.palette.text.default};
  font-size: ${({ theme }) => theme.typography.heading.size.md};
  font-weight: ${({ theme }) => theme.typography.weight.semibold};
`

export const DeviceTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  background: ${({ theme }) => theme.palette.background.default};
  border-radius: ${({ theme }) => theme.border.radius.md};
  overflow: hidden;
  box-shadow: ${({ theme }) => theme.elevation.bottom.sm};
`

export const TableHeader = styled.th`
  background: ${({ theme }) => theme.palette.background.alternate};
  border: ${({ theme }) => theme.border.width.sm} solid ${({ theme }) => theme.palette.border.default};
  padding: ${({ theme }) => theme.spacing[30]};
  text-align: left;
  font-weight: ${({ theme }) => theme.typography.weight.semibold};
  color: ${({ theme }) => theme.palette.text.default};
`

export const TableCell = styled.td`
  border: ${({ theme }) => theme.border.width.sm} solid ${({ theme }) => theme.palette.border.default};
  padding: ${({ theme }) => theme.spacing[30]};
  color: ${({ theme }) => theme.palette.text.default};
`

export const StatusBadge = styled.span<{ status: string }>`
  display: inline-block;
  padding: ${({ theme }) => `${theme.spacing[10]} ${theme.spacing[20]}`};
  border-radius: ${({ theme }) => theme.border.radius.sm};
  font-size: ${({ theme }) => theme.typography.body.size.sm};
  font-weight: ${({ theme }) => theme.typography.weight.medium};
  background-color: ${({ status, theme }) => {
    switch (status) {
      case 'received': return theme.palette.status.info;
      case 'diagnosed': return theme.palette.status.caution;
      case 'repaired': return theme.palette.status.success;
      case 'shipped': return theme.palette.success.default;
      default: return theme.palette.background.alternate;
    }
  }};
  color: ${({ theme }) => theme.palette.text.default};
`

export const ActionButton = styled.button<{ $variant: 'secondary' | 'danger' }>`
  padding: ${({ theme }) => `${theme.spacing[10]} ${theme.spacing[20]}`};
  margin-right: ${({ theme }) => theme.spacing[10]};
  border: none;
  border-radius: ${({ theme }) => theme.border.radius.sm};
  cursor: pointer;
  font-size: ${({ theme }) => theme.typography.body.size.sm};
  font-weight: ${({ theme }) => theme.typography.weight.medium};
  transition: all 0.2s ease-in-out;

  ${({ $variant, theme }) => {
    if ($variant === 'danger') {
      return `
        background-color: ${theme.palette.status.critical};
        color: ${theme.palette.text.alternate};
        &:hover {
          background-color: ${theme.palette.danger.default};
        }
      `;
    } else {
      return `
        background-color: ${theme.palette.background.alternate};
        color: ${theme.palette.text.default};
        border: ${theme.border.width.sm} solid ${theme.palette.border.default};
        &:hover {
          background-color: ${theme.palette.background.emphasis};
        }
      `;
    }
  }}
`

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${({ theme }) => theme.spacing[60]};
`

export const LoadingContainer = styled.div`
  text-align: center;
  padding: ${({ theme }) => theme.spacing[80]};
  color: ${({ theme }) => theme.palette.text.support};
`

export const ErrorContainer = styled.div`
  background: ${({ theme }) => theme.palette.status.critical};
  color: ${({ theme }) => theme.palette.text.alternate};
  padding: ${({ theme }) => theme.spacing[40]};
  border-radius: ${({ theme }) => theme.border.radius.sm};
  margin-bottom: ${({ theme }) => theme.spacing[40]};
`